import { ISpecializedCombo, useCombo, CreateOptionsParams, AfterLoadEventHandler } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useDespesaService } from "@services/DespesaService";
import { useThemeColor } from "@themes/Colors";
import { IEnum, KeyOfEnum, TDate } from "@utils/TypeHelpers";
import React from "react";
import { IEmpresa } from "./Empresa";

export enum EnumDespesaStatus {
    None = 0,
    Ativa = 1,
    Cancelada = 2
}

export enum EnumDespesaTipo {
    None = 0,
    Normal = 1,
    Recibo = 2
}

export interface IDespesa {
    despesaId: number
    
    despesaTabelaId: number
    empresaId: number
    
    descricao: string
    dataReferencia: TDate
    competenciaReferencia: string
    valor: number
    
    reciboReferencia: string

    status: EnumDespesaStatus
    statusDescription: string

    tipo: EnumDespesaTipo
    tipoDescription: string

    empresa: IEmpresa
}

export type IComboDespesaStatus = ISpecializedCombo<IEnum<EnumDespesaStatus>>;

export function useDespesaStatusCombo () : IComboDespesaStatus {
    const combo = useCombo<IEnum<EnumDespesaStatus>>();

    const despesaService = useDespesaService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((enumerator, index) => {
            return <MenuItem key={index} value={enumerator.value}>{params?.prefix}{enumerator.description}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IEnum<EnumDespesaStatus>>) => {
        combo.load(despesaService.listarStatus, afterLoad)
    }, [combo, despesaService.listarStatus]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export function useDespesaStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumDespesaStatus, string> = React.useMemo(() => ({
        [EnumDespesaStatus.None]: "",
        [EnumDespesaStatus.Ativa]: themeColor.status.verde,
        [EnumDespesaStatus.Cancelada]: themeColor.status.cinza,
    }), [themeColor.status.cinza, themeColor.status.verde]);

    return React.useMemo(() => map, [map]);
}